import type { ModelSalesFunnelStageLeads } from '@app/api/SalesFunnels';

// Cross-navigation snapshot of the last loaded Sales Funnel board result.
//
// The funnels board keeps its leads in local component state, so navigating to
// the Lead Card and back remounts the page and would otherwise trigger a fresh
// `GetSalesFunnelLeads` request for data that is already available. This
// module-scoped snapshot survives the remount (it is the funnels-board analogue
// of the registry's persisted result) and lets the board reuse the already
// loaded stages when the request context is unchanged.
//
// `signature` is a deterministic, size-independent identity of the request
// context (funnel + effective filters/stages). `requestedMaxSize` records how
// many leads were loaded so load-more state is preserved across navigation.
export interface LeadsFunnelsBoardSnapshot {
  signature: string;
  requestedMaxSize: number;
  stageLeads: ModelSalesFunnelStageLeads[];
}

let boardSnapshot: LeadsFunnelsBoardSnapshot | null = null;

export const getLeadsFunnelsBoardSnapshot =
  (): LeadsFunnelsBoardSnapshot | null => boardSnapshot;

export const setLeadsFunnelsBoardSnapshot = (
  snapshot: LeadsFunnelsBoardSnapshot
): void => {
  boardSnapshot = snapshot;
};
